/**
 * Traductions et formats (§8).
 *
 * Français par défaut, arabe avec RTL complet, anglais. Aucun texte n'est écrit
 * en dur dans un écran : tout passe par `t()` dès la première ligne.
 */
import fr from './fr.json' with { type: 'json' };
import ar from './ar.json' with { type: 'json' };
import en from './en.json' with { type: 'json' };
export const LANGUES = ['fr', 'ar', 'en'];
const catalogues = { fr, ar, en };
export function estLangue(valeur) {
    return LANGUES.includes(valeur);
}
/** Direction d'écriture, portée par l'attribut `dir` du document. */
export function direction(langue) {
    return langue === 'ar' ? 'rtl' : 'ltr';
}
/** Étiquette de la langue dans sa propre langue, pour le sélecteur. */
export function etiquetteLangue(langue) {
    return catalogues[langue][`langue.${langue}`] ?? langue;
}
/**
 * Construit le traducteur d'une langue. Une clé manquante n'est jamais masquée :
 * elle est retournée telle quelle et signalée en console, pour qu'un trou de
 * traduction se voie au lieu de s'afficher en français au milieu d'une page arabe.
 */
export function creerTraducteur(langue) {
    const catalogue = catalogues[langue];
    const t = ((cle, valeurs) => {
        const modele = catalogue[cle];
        if (modele === undefined) {
            if (typeof console !== 'undefined') {
                console.warn(`[i18n] clé manquante en « ${langue} » : ${cle}`);
            }
            return cle;
        }
        if (!valeurs)
            return modele;
        return modele.replace(/\{(\w+)\}/g, (correspondance, nom) => nom in valeurs ? String(valeurs[nom]) : correspondance);
    });
    t.langue = langue;
    t.direction = direction(langue);
    return t;
}
/** Clés présentes en français mais absentes d'une autre langue. Utilisé en test. */
export function clesManquantes(langue) {
    const reference = Object.keys(catalogues.fr).filter((c) => c !== '$commentaire');
    const cible = catalogues[langue];
    return reference.filter((c) => !(c in cible));
}
/* ── Formats ────────────────────────────────────────────────────────────────
   Le fuseau et la devise viennent de la configuration (§7 bis) : ils ne sont
   pas écrits ici. Stockage en UTC, affichage local (§5). */
const etiquettesIntl = {
    fr: 'fr-MA',
    ar: 'ar-MA',
    en: 'en-GB',
};
export function formaterMontant(montant, langue, devise) {
    return new Intl.NumberFormat(etiquettesIntl[langue], {
        style: 'currency',
        currency: devise,
    }).format(montant);
}
export function formaterDate(date, langue, fuseau, options = { dateStyle: 'long' }) {
    return new Intl.DateTimeFormat(etiquettesIntl[langue], {
        ...options,
        timeZone: fuseau,
    }).format(date);
}
export function formaterCreneau(debut, fin, langue, fuseau) {
    const format = new Intl.DateTimeFormat(etiquettesIntl[langue], {
        timeStyle: 'short',
        timeZone: fuseau,
    });
    return `${format.format(debut)} – ${format.format(fin)}`;
}
//# sourceMappingURL=index.js.map